import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonPrimary,
  MultiStepTracker,
  Step,
  ButtonSecondary,
} from '@americanexpress/dls-react';
import { IconEdit } from '@americanexpress/dls-icons';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';
/* eslint-enable  import/no-cycle -- need */
import {
  getLeJSONMapping, generateConfirmEntityTemplateData, validateUploadedFiles,
} from '../../utils/leUtils';
/* eslint-disable react/prop-types -- need */
const LeMappings = ({ childProps, props, filledFormData }) => {
  const {
    componentMapping, baseComponentTemplates, staticComponents,
  } = childProps;
  const {
    griffinFileInfo, setFormSubmissionPayload, formSubmissionPayload,
  } = props;
  const [currentEntity, setCurrentEntity] = useState(null);
  const [currentEntityIndex, setCurrentEntityIndex] = useState(-1);
  const [isChildElementsFetched, setIsChildElementsFetched] = useState(false);
  const { entityData } = formSubmissionPayload;

  const updateEntityData = (updatedEntity, updatedEntityIndex) => {
    const clonedEntityData = structuredClone(entityData);
    clonedEntityData.entities[updatedEntityIndex] = updatedEntity;
    let updatedFormSubmissionPayload = {
      ...formSubmissionPayload,
      entityData: clonedEntityData,
      formStatus: 'open',
      elemId: null,
    };
    if (updatedEntity.status === 'completed' && clonedEntityData.entities.length === updatedEntityIndex + 1) {
      updatedFormSubmissionPayload = {
        ...updatedFormSubmissionPayload,
        formStatus: 'completed',
      };
    }
    setFormSubmissionPayload({
      ...updatedFormSubmissionPayload,
    });
  };

  useEffect(() => {
    if (entityData && entityData?.entities && currentEntityIndex < 0) {
      childProps.childElements = [];
      entityData.entities = entityData?.entities.map((entity) => {
        let { individuals } = entity;
        individuals = individuals.map((individual) => {
          const { individualNameDocRequired, individualAddressDocRequired } = individual;
          if (individualNameDocRequired === 'Y' && individualAddressDocRequired === 'Y') {
            return {
              ...individual,
              individualNameAndAddressDocRequired: 'Y',
              individualNameDocRequired: 'N',
              individualAddressDocRequired: 'N',
            };
          }
          return individual;
        });
        return {
          ...entity,
          individuals,
        };
      });
      const openEntityIndex = entityData?.entities?.findIndex((entity) => entity?.status !== 'completed');
      if (entityData?.entities[openEntityIndex]) {
        const currentEntityData = entityData?.entities[openEntityIndex];
        const templateData = generateConfirmEntityTemplateData(currentEntityData, componentMapping);
        updateEntityData(templateData, openEntityIndex);
        setCurrentEntity(templateData);
        setCurrentEntityIndex(openEntityIndex);
      }
    }
  }, [entityData]);

  useEffect(() => {
    if (currentEntity && currentEntityIndex > -1 && entityData?.entities?.length > 0) {
      if (childProps.childElements.length === 0) {
        const formTemplate = {
          componentMapping, baseComponentTemplates, staticComponents,
        };

        const entityProps = {
          currentEntity: entityData.entities[currentEntityIndex],
          setCurrentEntity,
          entityIndex: currentEntityIndex,
        };

        const finalJSONMapping = getLeJSONMapping('docUpload', formTemplate, entityProps);
        childProps.childElements = finalJSONMapping;
        setIsChildElementsFetched(true);
      }
    }
  }, [currentEntity, currentEntityIndex, entityData]);

  const updateEntityStates = (updatedIndex) => {
    setCurrentEntityIndex(updatedIndex);
    const newEntityData = entityData?.entities[updatedIndex];
    setCurrentEntity(newEntityData);
    const templateData = generateConfirmEntityTemplateData(newEntityData, componentMapping);
    updateEntityData(templateData, updatedIndex);
  };

  const handleNextEntity = () => {
    window.scrollTo(0, 0);
    if (entityData?.entities && currentEntityIndex < entityData.entities.length - 1) {
      childProps.childElements = [];
      setIsChildElementsFetched(false);
      updateEntityStates(currentEntityIndex + 1);
    }
  };

  const handleBack = () => {
    window.scrollTo(0, 0);
    if (currentEntityIndex > 0) {
      childProps.childElements = [];
      setIsChildElementsFetched(false);
      updateEntityStates(currentEntityIndex - 1);
    }
  };

  const handleConfirm = () => {
    const validationParams = { griffinFileInfo, currentEntity, filledFormData };
    const uploadResponse = validateUploadedFiles(validationParams);
    if (uploadResponse.allDocumentsValid) {
      childProps.childElements = [];
      setIsChildElementsFetched(false);
      window.scrollTo(0, 0);
      const { currentEntity: updatedCurrEntity } = uploadResponse;
      setCurrentEntity(updatedCurrEntity);
      updateEntityData(updatedCurrEntity, currentEntityIndex);
    }
  };

  const handleEdit = () => {
    childProps.childElements = [];
    const updatedCurrEntity = { ...currentEntity };
    updatedCurrEntity.status = 'open';
    setCurrentEntity(updatedCurrEntity);
    updateEntityData(updatedCurrEntity, currentEntityIndex);
  };

  return (
    <>
      <div className="col-md-12">
        {entityData?.entities && (
        <MultiStepTracker currentStep={currentEntityIndex + 1}>
          {entityData?.entities.map((le) => (
            <Step key={le.taxId} label={`${le.leName}`} />
          ))}
        </MultiStepTracker>
        ) }
      </div>
      {currentEntity
        && (
          <div className="col-md-10 col-md-offset-1 text-align-center margin-3-tb heading-5-g dls-deep-blue">
            <div>{`${currentEntity.leName}-${currentEntity.taxId}`} </div>
            {currentEntity.status === 'completed' && <ButtonSecondary onClick={handleEdit} className="position-absolute-tr-xs-up btn-inline margin-responsive-r"><IconEdit className="dls-bright-blue" /> Edit</ButtonSecondary>}
          </div>
        )}

      <div className="col-md-10 col-md-offset-1">
        {currentEntity && isChildElementsFetched && (
          <>
            {
              constructChildStructure(childProps.childElements, props)
            }
          </>
        )}
      </div>

      {
        /**
         * This will disbaled? or onClick we'll have to evaluate
         * if all docs are uploaded or any other conditions
         * and then mark entity status as completed?
         */
        currentEntity?.status !== 'completed' && (
          <div className="col-md-12 margin-3-tb text-align-center">
            <div className="">
              <ButtonPrimary onClick={handleConfirm} type="submit" className="margin-auto-lr">
                Confirm Uploads
              </ButtonPrimary>
            </div>
          </div>
        )
      }

      <div className="col-md-12 margin-3-tb text-align-center">
        <ButtonPrimary
          onClick={handleBack}
          className="pad-1-lr margin-2-lr"
          disabled={currentEntityIndex === 0}
        >
          Previous Entity
        </ButtonPrimary>
        <ButtonPrimary
          onClick={handleNextEntity}
          disabled={(currentEntity && currentEntity.status !== 'completed') || (entityData && entityData.entities && currentEntityIndex === entityData.entities.length - 1)}
          className="pad-1-lr margin-2-lr"
        >
          Next Entity
        </ButtonPrimary>
      </div>
    </>
  );
};
  /* eslint-enable react/prop-types -- need */

LeMappings.propTypes = {
  props: PropTypes.objectOf(PropTypes.shape({
    entityData: PropTypes.objectOf(PropTypes.shape({
      entities: PropTypes.arrayOf(PropTypes.shape()),
    })),
    griffinFileInfo: PropTypes.arrayOf(PropTypes.shape()),
  })),
  childProps: PropTypes.objectOf(PropTypes.shape),
  filledFormData: PropTypes.objectOf(PropTypes.shape),
};

export default LeMappings;
